/***
 * Created on 2023/7/14
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useEffect, useState} from 'react';

function SwitchInput({label, value, setValue, callBack, opts}) {
    const [on, setOn] = useState(value);

    const onClick = (e) => {
        if (callBack && typeof callBack === 'function') {
            // setValue(prev => {
            //     callBack(e, !prev);
            //     return !prev;
            // });
            callBack(e, !value, opts);
        }
        else {
            setOn(prev => !prev);
        }
    }

    useEffect(() => {
        if (setValue && typeof setValue === 'function') {
            setValue(value);
        }
        else {
            setOn(value);
        }

    }, [value]);

    return (
        <div className="form-group">
            {label && <label>{label || ""}</label> }
            <div className="comp-switch !mt-9" onClick={onClick}>
                <div className={`q-switch switch-${!value ? 'off': 'on'}`}></div>
            </div>
        </div>
    );
}

export default SwitchInput;